import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-phone-forwarded",
  templateUrl: "./med-icon-phone-forwarded.component.html",
})
export class MedIconPhoneForwardedComponent extends SvgMixinComponent {}
